import { render, staticRenderFns } from "./_menu-container.svg.vue?vue&type=template&id=d79396aa&"
import script from "./_menu-container.svg.vue?vue&type=script&lang=js&"
export * from "./_menu-container.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports